<template>
  <div id="map" class="map"></div>
</template>

<script>
import * as mapboxgl from "mapbox-gl";
import config from "../assets/config";

export default {
  name: "Map",

  mounted() {
    this.initMap();
    setTimeout(() => {
      this.showLegend = true;
    }, 1700);
  },

  data() {
    return {
      showLegend: false
    };
  },

  computed: {
    tileURL() {
      return `https://bluegeo-tiles.s3-us-west-2.amazonaws.com/ERA/fernie_${this.currentYear}/{z}/{x}/{y}.png`;
    },
    currentYear() {
      return this.$store.state.data.year;
    },
    mapLayer() {
      return this.$store.state.data.mapLayer;
    },
    mapOptions() {
      return {
        container: "map",
        style: this.mapLayer,
        center: [-115, 49.55],
        zoom: 11.5
      };
    }
  },

  watch: {
    currentYear() {
      this.map.getSource("water-data").tiles = [this.tileURL];
      this.map.style.sourceCaches["water-data"].clearTiles();
      this.map.style.sourceCaches["water-data"].update(this.map.transform);
      this.map.triggerRepaint();
    },
    mapLayer(newLayer) {
      this.map.setStyle(newLayer);
    }
  },

  methods: {
    initMap() {
      // Initiate the map instance
      mapboxgl.accessToken = config.mbgltk;
      this.map = new mapboxgl.Map(this.mapOptions);

      // Initiate layers on load
      let self = this;
      this.map.on("load", () => {
        this.addLayers();

        this.map.on("style.load", function() {
          self.addLayers();
        });
      });
    },

    addLayers() {
      let self = this;
      let firstSymbolId;
      let layers = self.map.getStyle().layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol") {
          firstSymbolId = layers[i].id;
          break;
        }
      }

      self.map.addLayer(
        {
          id: "water-data",
          type: "raster",
          source: {
            type: "raster",
            tiles: [this.tileURL],
            tileSize: 256
          }
        },
        firstSymbolId
      );

      // Add a hillshade
      self.map.addSource("dem", {
        type: "raster-dem",
        url: "mapbox://mapbox.terrain-rgb"
      });
      self.map.addLayer(
        {
          id: "dem-hillshade",
          source: "dem",
          type: "hillshade",
          maxzoom: 12
        },
        firstSymbolId
        // "waterway-river-canal-shadow"
      );
    }
  }
};
</script>

<style scoped>
.map {
  padding: 0;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
